// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__aIeo5","qr-img":"footer_qr-img__+dp2-"};